import React, { createContext, useContext } from 'react';
import type { Atom, createStore } from 'jotai';
import { atom } from 'jotai';
import type { TaskLevelQuestionAnswersT } from '../../image/labelling';
const DEFAULT_ATOM = atom<TaskLevelQuestionAnswersT | undefined>(undefined);
const TaskLevelQuestionnaireContext = createContext<{
  atom: Atom<TaskLevelQuestionAnswersT | undefined>;
  store?: ReturnType<typeof createStore>;
}>({
  atom: DEFAULT_ATOM
});
type PropsT = {
  children: React.ReactNode;
  taskLevelQuestionnaireAtom?: {
    atom: Atom<TaskLevelQuestionAnswersT | undefined>;
    store?: ReturnType<typeof createStore>;
  };
};
export function TaskLevelQuestionnaireProvider({
  children,
  taskLevelQuestionnaireAtom
}: PropsT) {
  return <TaskLevelQuestionnaireContext.Provider value={taskLevelQuestionnaireAtom ?? {
    atom: DEFAULT_ATOM
  }}>
      {children}
    </TaskLevelQuestionnaireContext.Provider>;
}
export function useTaskLevelQuestionnaire() {
  return useContext(TaskLevelQuestionnaireContext);
}